<template>
  <div class="container">
    <h2>Disclaimer</h2>
      <p>We make all attempts and efforts to ensure the information on this app and website are accurate, reliable and up-to-date. We are neither liable nor responsible for any inaccurate information that may be stated on this app and/or website. We are not liable for any errors, financial loss, or damages of any kind that may result from use of, or reliance on, the information herein, and/or on this website. The information on this app and/or website is proprietary, copyrighted and protected by applicable copyright laws.</p>
  </div>
</template>

<script>

export default {
  name: 'Disclaimer',

}
</script>

<style scoped>
  .container {
    text-align: left;
  }
</style>
